// store.js
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from "./authSlice";
import notificationsReducer from "./notificationsSlice";
import websocketReducer from "./websocketSlice"; // Import websocket reducer

import { injectStore } from "./../utils/api";
import websocketMiddleware from "../middlewares/websocketMiddleware";

// Configure persistence for auth reducer
const persistConfig = {
  key: "auth",
  storage,
};

// Configure persistence for notifications (optional - you might want notifications to persist)
const notificationsPersistConfig = {
  key: "notifications",
  storage,
};

// Configure persistence for websocket (optional - you might want to persist some websocket state)
const websocketPersistConfig = {
  key: "websocket",
  storage,
  // Only persist notifications, not socket connection state
  whitelist: ["notifications"],
};

// Create persisted reducers
const persistedAuthReducer = persistReducer(persistConfig, authReducer);
const persistedNotificationsReducer = persistReducer(
  notificationsPersistConfig,
  notificationsReducer
);
const persistedWebsocketReducer = persistReducer(
  websocketPersistConfig,
  websocketReducer
);

const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    notifications: persistedNotificationsReducer,
    websocket: persistedWebsocketReducer, // Add websocket reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          "auth/login/rejected",
          "websocket/connect/pending",
          "websocket/connect/fulfilled",
          "websocket/connect/rejected",
          "websocket/disconnect/pending",
          "websocket/disconnect/fulfilled",
          "websocket/disconnect/rejected",
          "websocket/handleNewChange", // Add this to ignore serialization check
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
        ],
        ignoredPaths: ["auth.error"],
      },
    }).concat(websocketMiddleware), // Add websocket middleware here
});

export const persistor = persistStore(store);
injectStore(store);

export default store;
